var m = "云视频";
import carLocate from "@/components/locate/carLocate";
//import allLocate from "@/components/locate/allLocate";
import locus from "@/components/locus/";
//import locusPeson from "@/components/locusPeson/";
//import carVideo from "@/components/video/carVideo";
//import byVideo from "@/components/video/byVideo";
//import carVideoHistory from "@/components/video/carVideoHistory";
//import byCarVideoHistory from "@/components/video/byCarVideoHistory";
//import oil from "../../node_modules/common/src/components/oil/oil";
//import temp from "../../node_modules/common/src/components/temp/";
var data = [
  
  {
    path: "/locus",
    component: locus,
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/carLocate",
    component: carLocate,
    meta: {
      keepAlive: true,
    },
  },

];
export default data;



// WEBPACK FOOTER //
// ./src/router/locate.js